<template>
  <div class="relative">
    <div
      class="absolute right-0 top-0 flex items-center bg-black/40 text-xs rounded-sm text-white z-10 px-1"
      v-if="imagesCount > 1"
    >
      <base-icon
        name="camera"
        class="text-xs ml-1"
      />
      {{ imagesCount }}
    </div>

    <swiper
      :slides-per-view="1"
      :modules="modules"
      :pagination="{ enabled: true }"
      class="t-sliderListProductImage w-36 h-36 sm:w-full"
    >
      <swiper-slide
        v-for="file in images"
        :key="file.title"
        class="slide"
      >
        <base-image
          :src="file.path"
          :title="title"
          class="w-full h-full aspect-square rounded-xl object-contain"
          :class="{ 'opacity-40': !inStock }"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { FreeMode, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import BaseImage from '~/components/base/BaseImage.vue';
import BaseIcon from '~/components/base/BaseIcon.vue';

const props = defineProps({
  files: {
    type: Array,
    required: true,
  },
  inStock: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});

const modules = [FreeMode, Pagination];

const images = computed(() => {
  return props.files.filter(f => f.type_enum === 0);
});

const imagesCount = computed(() => {
  return images.value.length;
});
</script>

<style lang="scss">
.t-sliderListProductImage {
  .swiper-pagination {
    bottom: -4px !important;
  }

  .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    margin: 0 2px !important;
  }

  .swiper-pagination-bullet-active {
    background: $color-neutral-400;
  }
}
</style>
